import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';
import { InstitutionService } from 'src/app/shared/services/institution.service';
import { AppSettings } from '../../../app.constant';

@Component({
  selector: 'institution-table',
  templateUrl: './institution-table.component.html',
  styleUrls: ['./institution-table.component.css']
})

export class InstitutionTableComponent implements OnInit {
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  displayedColumns: string[] = ['InstitutionCode', 'InstitutionName', 'RegistrationNo', 'Edit'];
  httpResponseMessage: any;
  public progressBar: boolean = true;
  post: any;
  posts: any;
  public resultdata: any;
  dataSource;
  Institution: any;
  status: any;
  errorMessage: String;
  durationInSeconds = 2;

  @Output() messageEvent = new EventEmitter<string>();
  constructor(
    private _institutionservice: InstitutionService,
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog, ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this._institutionservice.refreshNeeded$
      .subscribe(() => {
        this.getAllInstitution();
      })
    this.getAllInstitution();
  }

  getAllInstitution() {
    this._institutionservice.getAllInstitution(AppSettings.API_ENDPOINT + AppSettings.GetAllInstitution)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }
        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onEditInstitution(param: any): void {
    var o = { PK_InstitutionID: param.PK_InstitutionID }
    this.post = JSON.stringify(o);
    this._institutionservice.getInstitutionByID(AppSettings.API_ENDPOINT + AppSettings.GetInstitutionByID, this.post).subscribe(
      data => {
        this.Institution = data;
        this.messageEvent.emit(this.Institution);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteInstitution(param: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Institution",
      data: param.InstitutionName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        var o = { PK_InstitutionID: param.PK_InstitutionID }
        this.post = JSON.stringify(o);
        this._institutionservice.deleteInstitutionByID(AppSettings.API_ENDPOINT + AppSettings.DeleteInstitution, this.post).subscribe(
          data => {
            this.httpResponseMessage = data
            this.openSnackBar(this.httpResponseMessage, '');
          },
          error => this.errorMessage = <any>error)
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}
